import { AppConfig, NotificationItem, ModalItem } from "@/models/AppConfig";
export const ConfigGetters = {
	NOTIFICATION_LIST: 'NOTIFICATION_LIST',
	IS_LOADING_IN_PROGRESS: 'IS_LOADING_IN_PROGRESS',
	MODALS_LIST: 'MODALS_LIST',
	LAST_MODAL_UUID: 'LAST_MODAL_UUID'
}

export default {
	[ConfigGetters.NOTIFICATION_LIST]: (state: AppConfig): NotificationItem[] => {
		return state.notifications;
	},
	[ConfigGetters.IS_LOADING_IN_PROGRESS]: (state: AppConfig): boolean => {
		return state.httpInProgress;
	},
	[ConfigGetters.MODALS_LIST]: (state: AppConfig): ModalItem[] => {
		return state.modals;
	},
	[ConfigGetters.LAST_MODAL_UUID]: (state: AppConfig): string => {
		if (!state.modals.length) {
			return '';
		}

		return state.modals[state.modals.length - 1].uuid;
	}
}
